import React from "react";
import { I18n } from "@aws-amplify/core";
import { get } from "lodash";

import { fetchGet } from "../../api/fetch";

import Dialog from "@material-ui/core/Dialog";

import CustomButton from "../Common/CustomButton";
import ProfileForm from "../Profiles/ProfileForm/ProfileForm";

import { getAttributeValue } from "../../utils/profile";
import AddAssociation2 from "../Profiles/ProfileAssociations/AddAssociation2";


const ProfileSearchCreateProfile = (props) => {
  const { profileType, handleProfileCreation, flow } = props;
  const [open, setOpen] = React.useState(false);
  const [associate, setassociate] = React.useState(false);
  const [prof, setprof] = React.useState();

  const fetchNewProfile = async (p) => {
    try {
      let profile = await fetchGet(`profiles/${get(p, ["id"])}`);
      profile.firstname = getAttributeValue(profile, 31);
      profile.lastname = getAttributeValue(profile, 32);
      profile.email = getAttributeValue(profile, 33);

      if (flow === "newAccount"){
        setassociate(true)
        setprof(profile)
      } else {
        handleProfileCreation(profile);
      }
      setOpen(false);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <CustomButton color="primary" onClick={() => setOpen(true)}>
        {I18n.get("profiles_newProfile")}
      </CustomButton>
      <Dialog open={associate} maxWidth="xl">
        <AddAssociation2
          setOpen={setassociate}
          permissions={null}
          profile={prof}
          handleComplete={handleProfileCreation}
        />
      </Dialog>
      <Dialog open={open} maxWidth="xl">
        <ProfileForm
          profileType={profileType}
          setCreatedProfile={(p) => fetchNewProfile(p)}
          close={() => setOpen(false)}
          express={props.express}
          newProfilePhotos={props.newProfilePhotos}
          flow={flow}
        />
      </Dialog>
    </>
  );
};

export default ProfileSearchCreateProfile;
